module.exports = __webpack_public_path__ + "static/media/Neo-Bank-App-06.3e8e03ed.png";